import { render, staticRenderFns } from "./InventoryItemDispatchTable.vue?vue&type=template&id=0461bc07&scoped=true&"
import script from "./InventoryItemDispatchTable.vue?vue&type=script&lang=js&"
export * from "./InventoryItemDispatchTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0461bc07",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDataTable,VMenu})
